/*
 * Copyright © 2024 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {Directive, inject, TemplateRef} from '@angular/core';

/**
 * Used to define the edit mode template of a click-2-edit element.
 */
@Directive({
    selector: '[dvlibEditMode]',
})
export class EditModeDirective {
    public readonly template = inject<TemplateRef<any>>(TemplateRef);
}
